import styled from '@emotion/styled'
import { SplitButtonDropdown } from 'view/components/menus'
import { SpreadsheetMappingSelectboxField } from '../entity'

export const SpreadsheetParseMappingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: self-end;
`

export const SpreadsheetParseMappingActionsButton = styled(SplitButtonDropdown)`
  width: 135px;
  padding-left: 10px;
`

export const SpreadsheetParseMappingSelectbox = styled(SpreadsheetMappingSelectboxField)`
  flex: 1;
`
